import {AxiosError} from 'axios'

import {API} from '../../../networking/http'
import {QueryOptions, UseQueryOptions} from '../../helpers/types'
import {getPromoErrorFromResponse} from '../../promo-codes/helpers'
import {SubscriptionData} from '../types'

export type GetSubscriptionParams = string

export type GetSubscriptionQueryParams = {
  promoCode?: string
  // List amount of the first cycle (maybe pro-rated): prices[i] then carry the exact
  // firstCyclePrice / firstCyclePromoDiscount for it (server #2835). Only sent with a code.
  firstCyclePrice?: number
  id?: string
}

export type GetSubscriptionQueryReturnType = SubscriptionData | null

type Par = QueryOptions<GetSubscriptionParams, GetSubscriptionQueryParams, GetSubscriptionQueryReturnType>

type QueOp = UseQueryOptions<
  GetSubscriptionQueryReturnType,
  AxiosError,
  GetSubscriptionQueryReturnType,
  [string, GetSubscriptionQueryParams?]
>

export const makeGetSubscriptionEndpoint = (id: string) => `memberships/${id}/plain`

export const getSubscriptionQuery = ({query, params: id, ...rest}: Par): QueOp => {
  return {
    queryKey: [
      'getSubscriptionQuery',
      {
        id: id || '',
        promoCode: query?.promoCode,
        firstCyclePrice: query?.promoCode ? query.firstCyclePrice : undefined,
      },
    ],
    cacheTime: 1000 * 60,
    enabled: Boolean(id),
    // A rejected promo code comes back as a 4xx with a PROMO_* code: no point retrying it.
    retry: (failureCount, error) => !getPromoErrorFromResponse(error) && failureCount < 3,
    ...rest,
    refetchOnWindowFocus: rest.refetchOnWindowFocus || false,
    queryFn: ({queryKey: [_, config]}) => {
      if (!id) {
        return Promise.resolve(null)
      }
      const params: GetSubscriptionQueryParams = {}
      if (config?.promoCode) {
        params.promoCode = config.promoCode
        if (config.firstCyclePrice !== undefined) {
          params.firstCyclePrice = config.firstCyclePrice
        }
      }
      return API.get<GetSubscriptionQueryParams, GetSubscriptionQueryReturnType>(makeGetSubscriptionEndpoint(id), {
        params,
      }).then((res) => res.data)
    },
  }
}
